import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const Login = (props) => {
  const host = "https://noteboss-backend.onrender.com";
  let navigate = useNavigate();
  useEffect(() => {
    props.showLoading();
    if (localStorage.getItem("auth-token") !== null) {
      navigate("/");
    }
    setTimeout(() => {
      props.completeLoading();
    }, 100);
    //eslint-disable-next-line
  }, []);
  document.title = props.title;
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    props.showLoading();
    e.preventDefault();
    let url = `${host}/api/auth/login`;
    let response = await fetch(url, {
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        email: credentials.email.toLowerCase(),
        password: credentials.password,
      }),
    });

    let data = await response.json();
    props.completeLoading();
    if (data.success === true) {
      localStorage.setItem("auth-token", data.authToken);
      localStorage.setItem("userName", data.name);
      localStorage.setItem("userEmail", data.email);
      props.showAlert("success", data.name, "Logged In Successfully");
      navigate("/");
    } else if (data.error === "userNotFound") {
      props.showAlert(
        "warning",
        "Warning",
        "Email not registered with us, Kindly SignUp"
      );
    } else {
      props.showAlert("danger", "Error", "Invalid Credentials");
    }
  };

  const handleForgetPassword = async (e) => {
    if (credentials.email !== "") {
      try {
        e.preventDefault();
        props.showLoading();
        let url = `${host}/api/auth/forgetpassword`;
        let response = await fetch(url, {
          headers: {
            "content-type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            email: credentials.email.toLowerCase(),
          }),
        });
        let data = await response.json();
        props.completeLoading()
        if(data.success === true){
          props.showAlert("success", "Success", `Password Reset Link Sent to "${data.userEmail}"`)
        }else if(data.error === "User Not Found"){
          props.showAlert("warning", "Warning", "User Not Registered With Us");
        }else if(data.errors[0].msg === "Enter a Valid Email ID"){
          props.showAlert("warning", "Warning", "Please Enter Valid Email Id");
        }
      } catch (error) {
        props.showAlert("danger", "Error", "Some Internal Error Occured")
      }
    } else {
      props.showAlert("warning", "Warning", "Please Enter Email Id");
    }
  };
  return (
    <div
      className={`container mt-4 mb-2 d-flex flex-column justify-content-center align-items-center ${
        props.theme === "dark" ? "text-light" : ""
      }`}
    >
      <h2 className="mt-2">
        Login to <span className="text-danger">NoteBoss</span>
      </h2>
      <span className="fs-6 mb-4 text-secondary">Welcome Back!</span>
      <form onSubmit={handleSubmit} id="loginForm">
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email address
          </label>
          <input
            type="email"
            className={`form-control input-manual-style ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            id="email"
            name="email"
            aria-describedby="emailHelp"
            onChange={onChange}
            value={credentials.email}
            required
          />
          <div
            id="emailHelp"
            className={`form-text ${
              props.theme === "dark" ? "text-secondary" : ""
            }`}
          >
            We'll never share your email with anyone else.
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className={`form-control input-manual-style ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            name="password"
            id="password"
            onChange={onChange}
            value={credentials.password}
            autoComplete="off"
            required
          />
          <span
            className="mb-3 text-secondary cursorPointer float-end"
            style={{ fontSize: "13px" }}
            onClick={handleForgetPassword}
          >
            Forget Password?
          </span>
        </div>
        <button type="submit" className="btn btn-large btn-primary">
          Login
        </button>
      </form>
      <span className="text-center mt-3">
        New on NoteBoss?{" "}
        <Link className="text-decoration-none" to="/auth/signup">
          Sign Up Here
        </Link>
      </span>
    </div>
  );
};

export default Login;
